import { render } from "./EditMetadataModal.vue?vue&type=template&id=0b0ec29c&scoped=true&ts=true"
import script from "./EditMetadataModal.vue?vue&type=script&lang=ts"
export * from "./EditMetadataModal.vue?vue&type=script&lang=ts"

import "./EditMetadataModal.vue?vue&type=style&index=0&id=0b0ec29c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b0ec29c"]])

export default __exports__